import { config } from '@xingternal/hops';

type Route = string;
type RouteResolver = (
  arg0: string | number,
  arg1: string | number,
  arg2: string | number
) => string;
export interface ApiPathConfig {
  [key: string]: Route | RouteResolver;
}

const apiUrl = config.apiUrl || '';
const adminUrl = config.adminUrl || '';

export const ApiPathConfig = {
  // NOTE: /legal/api routes to public api. See olympus Ingress
  // /legal/api/admin goes matches the admin ingresses. See olympus rules.
  publicTermsIndex: `${apiUrl}/legal/api/pages`,
  publicTermsShow: (slug: string): string =>
    `${apiUrl}/legal/api/pages/terms_and_conditions/${slug}`,
  publicLegalNoticesShow: (slug: string): string =>
    `${apiUrl}/legal/api/pages/legal_notices/${slug}`,
  publicOtherLegalPages: (slug: string): string =>
    `${apiUrl}/legal/api/pages/other_legal_pages/${slug}`,
  publicTermsShowPdf: (slug: string): string =>
    `${apiUrl}/legal/api/pages/terms_and_conditions/${slug}.pdf`,

  getCurrentUser: `${adminUrl}/admin/legal/api/me`,
  adminTermsIndex: `${adminUrl}/admin/legal/api/pages/terms_and_conditions`,
  adminTermsDetails: (slug: string): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/${slug}`,
  adminVersionsUpdate: (versionId: number): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/versions/${versionId}`,
  createPage: `${adminUrl}/admin/legal/api/pages/terms_and_conditions`,
  createVersion: `${adminUrl}/admin/legal/api/pages/terms_and_conditions/versions`,
  adminShowPreview: (
    versionId: number | string,
    genericVersionId: number | string = null,
    locale: string
  ): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/preview/${versionId}?locale=${locale}&generic_id=${genericVersionId}`,
  adminPrintPreview: (
    versionId: number,
    genericVersionId: number = null,
    locale: string
  ): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/preview/${versionId}.pdf?locale=${locale}&generic_id=${genericVersionId}`,
  adminVersionPublish: (versionId: number): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/versions/${versionId}/publish`,
  adminVersionRevert: (versionId: number): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/versions/${versionId}/revert`,
  adminClonePage: (pageId: number): string =>
    `${adminUrl}/admin/legal/api/pages/terms_and_conditions/${pageId}/clone`,
};
